import React from 'react';

import {
  CapaQuotationPartnerStrategy,
  CapaQuotationPartnerStatus
} from '@generated/graphql';

import { IconButton } from '@material-ui/core';

import { ChevronLeftOutlined } from '@material-ui/icons';

import { CustomizedTypography } from '@components/Customized';

import useDrawer from '../useDrawer';
import useStyles from '../useStyles';

interface Props {
  matches: boolean;
  partner?: CapaQuotationPartnerStrategy;
  onHandlePartnerInfo: () => void;
}
const ChatHeaderPresenter = ({ partner, onHandlePartnerInfo }: Props) => {
  const classes = useStyles();

  const isWithdraw = partner?.status === CapaQuotationPartnerStatus.Deleted;

  const [, updateDrawer] = useDrawer();

  return (
    <div className={classes['Chat-Header-root']}>
      <IconButton
        className="go-back-button"
        onClick={() => {
          updateDrawer();
        }}
      >
        <ChevronLeftOutlined />
      </IconButton>

      <div className="user-name" onClick={() => onHandlePartnerInfo()}>
        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          fontWeight="500"
        >
          {partner?.organizationName}
          {isWithdraw && '(탈퇴함)'}
        </CustomizedTypography>
      </div>

      <div />
    </div>
  );
};

export default ChatHeaderPresenter;
